import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SaveGlyph = /*#__PURE__*/createElement("g", {
  id: "save"
}, /*#__PURE__*/createElement("path", {
  d: "m68.7 22.2-6.9-6.9c-.3-.3-.6-.4-1-.4H19.2c-2.3 0-4.2 1.9-4.2 4.2v45.7c0 2.3 1.9 4.2 4.2 4.2h45.6c2.3 0 4.2-1.9 4.2-4.2V23.2c.1-.3 0-.6-.3-1zm-21.8-4.4h6.9v12.5c0 .8-.6 1.4-1.4 1.4h-5.5V17.8zm-16.6 0h13.8v13.8H31.7c-.8 0-1.4-.6-1.4-1.4V17.8zm26.3 48.3h-29V49.5h29.1l-.1 16.6zm9.7-1.3c0 .8-.6 1.4-1.4 1.4h-5.5v-18c0-.8-.6-1.4-1.4-1.4H26.2c-.8 0-1.4.6-1.4 1.4v18h-5.5c-.8 0-1.4-.6-1.4-1.4V19.2c0-.8.6-1.4 1.4-1.4h8.3v12.5c0 2.3 1.9 4.2 4.2 4.2h20.8c2.3 0 4.2-1.9 4.2-4.2V17.8h3.6l6.1 6.1v40.9h-.2z"
}));
const Save = createSvg({
  name: 'save',
  path: SaveGlyph
});

export default Save;
export { SaveGlyph };
